export async function getAdress(ip = "2.63.137.255") {
    const response = await fetch(`https://ipapi.co/${ip}/json/`)
    return await response.json()
}